export default __webpack_public_path__ + "static/aed_b.5899d416ed6028c7cfb05cf63f500cb7.png";